export default class Embaralha {
    embaralhar(){
        const senhas = document.querySelector('.gerador-senha')
        const btnEmbaralha = document.querySelector('.btnEmbaralha')
        const char = document.getElementById('char')
        const valores = []
        char.addEventListener('input', e => {
            const el = e.target
            let valor = el.value
            valores.push(valor)
            if(valores.length > 1) {
                valores.shift()
            }
        })
        btnEmbaralha.addEventListener('click', e => {
            let newWord = []
            for (let i = 0; newWord.length < valores[0]; i++) {
                let el = senhas.innerText[i]
                newWord.push(el)
            }
            let shuffled = newWord.sort(() => Math.random() - 0.5);
            senhas.innerText = shuffled.join('')
        })
    }
}